<div class="app-avatar">
    <p-avatar [label]="initials" shape="circle"></p-avatar>
    @if (status && statusMap[_status]) {
        <div class="app-avatar--status"
             [pTooltip]="status"
             [ngStyle]="{background: statusColorMap[_status]}">
            <i [class]="statusMap[_status]"></i>
        </div>
    }
</div>
